import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  user: state.user.user,
  originalBreedList: state.pet.breeds,
  pet: state.pet.pet,
  activeComponentOptions: state.statsbar.activeComponentOptions,
});

angular
  .module('myConsultApp')
  .controller(
    'petCreateController',
    ($ngRedux, $scope, $rootScope, $timeout, $filter, $http, ENV) => {
      $scope.tabId = 'pet-information';
      $scope.attemptedTabChange = 'pet-information';
      $scope.attemptedTabPosition = 0;
      $scope.isFormDataChanged = false;
      $scope.petProcessing = false;
      $scope.owner_identifications = [];

      $scope.resetTabPosition = (tabId = 'pet-information', position = 0) => {
        $scope.tabId = tabId;
        const indicator = document.querySelector('.create-pet .indicator');
        const tabs = document.querySelectorAll('.create-pet .tab');
        if (indicator) {
          indicator.style.marginLeft = `${position * tabs[0].offsetWidth}px`;
          indicator.style.width = tabs[0].offsetWidth ? `${tabs[0].offsetWidth}px` : `198px`;
        }
      };

      $scope.petEditTabChanges = (tabId, position) => {
        $scope.isFormDataChanged = false;
        $scope.isFormDataChanged = !angular.equals($scope.currentPet, $rootScope.adminPet);
        $scope.attemptedTabChange = tabId ?? $scope.attemptedTabChange;
        $scope.attemptedTabPosition = position ?? $scope.attemptedTabPosition;

        if (!$scope.isFormDataChanged) {
          $scope.resetTabPosition($scope.attemptedTabChange, $scope.attemptedTabPosition);
        }
      };

      $scope.editPetDialogOptions = {
        heading: 'Warning!',
        message:
          'You have unsaved changes on this tab! Press OK to continue (undo changes), or Cancel to stay on the current tab and continue editing.',
        buttons: [
          {
            label: 'OK',
            href: '#',
            clickFn: () => {
              $scope.setPetData();
              $scope.isFormDataChanged = false;
              $scope.petEditTabChanges();
            },
          },
          {
            label: 'Cancel',
            href: '#',
            clickFn: () => {
              $scope.isFormDataChanged = false;
            },
          },
        ],
      };

      $scope.clearPetEditCreate = () => {
        $scope.resetTabPosition();
        $scope.petProcessing = false;
        $scope.isFormDataChanged = false;
        $scope.todaysDate = new Date();
        $scope.pet_create_edit_heading = 'Create a Pet';
        $scope.container_class = 'create-pet-container';
        $scope.currentPet = {
          species: null,
          is_male: null,
          date_of_birth: null,
          petprofile: {},
          is_active: null,
        };
        $scope.error = {
          status: false,
          details: '',
          highlightedFields: { breed: [] },
        };
        $scope.petDobValid = true;
        $scope.breedList = null;
        $('#create-pet-dob').val(null);
        $scope.lastBreedValue = null;
        $scope.currentBreedTitle = null;
        $('#petBreedList_value').val(null);
        $scope.isInvalid = false;
        if ($scope.createpet !== undefined) {
          $scope.createpet.$setPristine();
          $scope.createpet.$setUntouched();
        }
        if ($scope.medicalInformation !== undefined) {
          $scope.medicalInformation.$setPristine();
          $scope.medicalInformation.$setUntouched();
        }
        $scope.pet_success = null;
        $scope.medical_success = null;
        $scope.provider_success = null;
        $scope.showVetSelector = false;
        var e = document.getElementById('pet-owner-name_value');
        if (!$rootScope.isUserPage && e != undefined) {
          e.value = '';
          var $e = angular.element(e);
          $e.triggerHandler('input');
        }
        var e = document.getElementById('petBreedList_value');
        if (e != undefined) {
          e.value = '';
          var $e = angular.element(e);
          $e.triggerHandler('input');
        }
        var e = document.getElementById('datepicker-result-pet-dob');
        if (e != undefined) {
          e.value = '';
          var $e = angular.element(e);
          $e.triggerHandler('input');
        }
      };

      $scope.clearPetEditCreate();

      const componentVisibleListener = $rootScope.$watch('componentOpened', () => {
        $scope.resetTabPosition();
        if (!$rootScope.componentOpened) {
          $scope.clearPetEditCreate();
        } else if (!$scope.currentPet.id) {
          $scope.setPetData();
        }
      });

      $scope.setPetData = () => {
        if ($rootScope.adminPet) {
          $scope.currentPet = angular.copy($rootScope.adminPet);
          $scope.owner_identifications = [];
          angular.forEach($scope.currentPet.petprofile, (value, key) => {
            if (key.startsWith('id_') && value) {
              $scope.owner_identifications.push(key);
            }
          });
          $scope.pet_create_edit_heading = 'Edit Pet: ' + $scope.currentPet.name;
          $scope.container_class = 'edit-pet-container';
          $scope.lastBreedValue = $scope.currentPet.breed;
          $scope.setBreedList();
        }
      };

      const petEditListener = $rootScope.$watch('adminPet', () => {
        if ($rootScope.adminPet) {
          $scope.setPetData();
          $scope.lastBreedValue = $rootScope.adminPet.breed;
          $scope.currentBreedTitle = $scope.getBreedFromList($rootScope.adminPet.breed);
          if (!$rootScope.isUserPage) {
            $rootScope.userId = $rootScope.adminPet.owner;
          }
        } else {
          $scope.clearPetEditCreate();
        }
      });

      const breedListener = $scope.$watch('originalBreedList', () => {
        if (
          $scope.originalBreedList &&
          $scope.originalBreedList.length > 1 &&
          $rootScope.adminPet
        ) {
          $scope.currentBreedTitle = $scope.getBreedFromList($rootScope.adminPet.breed);
        }
      });

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.closeEditAndOpenPet = async () => {
        $scope.resetTabPosition();
        await $scope.clearPetEditCreate();

        if ($rootScope.adminPetId && $rootScope.isUserPage) {
          await $rootScope.closeComponentAndOpenNew();
          await $rootScope.refreshAdminPet($rootScope.adminPetId);
        } else {
          await $rootScope.closeComponent();
        }
      };

      $scope.isEmptyObject = (obj) => {
        return obj && Object.keys(obj).length === 0;
      };

      $scope.selectPetOwner = (data) => {
        $rootScope.userId = data.id;
      };

      $scope.searchClients = (query) => {
        return $scope
          .getUsers($http, ENV, {
            application_subscription: 'has',
            is_active: true,
            is_anonymized: false,
            autocomplete: true,
            groups: 2,
            order: 'last_name',
            search: query,
          })
          .then((res) => {
            return res;
          });
      };

      $scope.searchClientsPage = (query) => {
        return $scope.getUsersByUrl($http, query).then((res) => {
          return res;
        });
      };

      $scope.selectSpecies = (option) => {
        if (option && option.id) {
          $scope.currentPet.species = option.id;
        } else {
          $scope.currentPet.species = null;
        }
        if (
          $scope.lastBreedValue &&
          $scope.currentPet.species &&
          $scope.getBreedSpecies($scope.lastBreedValue, $scope.currentPet.species)
        ) {
          $scope.lastBreedValue = $scope.lastBreedValue; // why the reassignment?
        } else {
          $scope.lastBreedValue = null;
        }
        $scope.setBreedList();

        // Check if current breed should be updated
        if ($scope.currentBreedTitle && $scope.breedList) {
          const index = $scope.breedList.findIndex(
            (item) => item.name === $scope.currentBreedTitle,
          );

          if (index === -1) {
            $scope.currentBreedTitle = null;
            $('#petBreedList_value').val(null);
          } else {
            $('#petBreedList_value').val($scope.currentBreedTitle);
          }
        } else {
          $scope.currentBreedTitle = null;
          $('#petBreedList_value').val(null);
        }
      };

      $scope.setSpeciesList = () => {
        return $scope
          .getSpecies($http, ENV, {
            paginate: false,
            order: 'id',
          })
          .then((res) => {
            return res;
          });
      };

      $scope.selectGender = (option) => {
        $scope.currentPet.is_male = option.value;
      };

      $scope.setGenderList = () => {
        return $scope.getGenders().then((res) => {
          return res;
        });
      };

      $scope.selectBreed = (item) => {
        $scope.lastBreedValue = item ? item.originalObject.id : null;
      };

      $scope.getBreedFromList = (breedId) => {
        var breedName = null;
        angular.forEach($scope.originalBreedList, (value) => {
          if (value.id === breedId) {
            breedName = value.name;
            return value.name;
          }
        });
        return breedName;
      };

      $scope.getBreedSpecies = (breedId, speciesId) => {
        var breedSpecies = false;
        angular.forEach($scope.originalBreedList, (value) => {
          if (value.species === speciesId && value.id === breedId) {
            breedSpecies = true;
            return true;
          }
        });
        return breedSpecies;
      };

      $scope.setBreedList = () => {
        const auxBreedList = [];
        angular.forEach($scope.originalBreedList, (value) => {
          if (value.species === $scope.currentPet.species) {
            auxBreedList.push(value);
          }
        });
        $scope.breedList = auxBreedList;
      };

      $scope.updateDateOfBirth = (val) => {
        $scope.currentPet.date_of_birth = val;
      };

      $scope.selectStatus = (option) => {
        $scope.currentPet.is_active = option.value;
      };

      $scope.setStatusList = () => {
        return $scope.getStatuses().then((res) => {
          return res;
        });
      };

      $scope.selectNeutered = (option) => {
        $scope.currentPet.petprofile.sterilized = option.value;
      };

      $scope.setNeuteredList = () => {
        return $scope.getNeutered().then((res) => {
          return res;
        });
      };

      $scope.selectSpayed = (option) => {
        $scope.currentPet.petprofile.sterilized = option.value;
      };

      $scope.setDeclawedOptions = () => {
        return $scope.getDeclawedOptions().then((res) => {
          return res;
        });
      };

      $scope.selectDeclawed = (option) => {
        $scope.currentPet.petprofile.declawed = option.value;
      };

      $scope.setSpayedList = () => {
        return $scope.getSpayed().then((res) => {
          return res;
        });
      };

      $scope.selectMedicalCondition = (option) => {
        if (option.state) {
          $scope.currentPet.petprofile.medical_conditions.push(option.value);
        } else {
          const index = $scope.currentPet.petprofile.medical_conditions.indexOf(option.value);
          if (index > -1) {
            $scope.currentPet.petprofile.medical_conditions.splice(index, 1);
          }
        }
      };

      $scope.selectFamilyMedicalCondition = (option) => {
        if (option.state) {
          $scope.currentPet.petprofile.family_medical_conditions.push(option.value);
        } else {
          const index = $scope.currentPet.petprofile.family_medical_conditions.indexOf(
            option.value,
          );
          if (index > -1) {
            $scope.currentPet.petprofile.family_medical_conditions.splice(index, 1);
          }
        }
      };

      $scope.setMedicalConditionList = () => {
        return $scope.getMedicalConditionOptions($http, ENV).then((res) => {
          return res;
        });
      };

      $scope.selectOwnerIdentification = (option) => {
        $scope.currentPet.petprofile[option.value] = option.state;
        if (option.state) {
          $scope.owner_identifications.push(option.value);
        } else {
          const index = $scope.owner_identifications.indexOf(option.value);
          if (index > -1) {
            $scope.owner_identifications.splice(index, 1);
          }
        }
      };

      $scope.setOwnerIdentificationList = () => {
        return $scope.getOwnerIdentifications().then((res) => {
          return res;
        });
      };

      $scope.expandVetSelector = () => {
        if(!$scope.showVetSelector){
          $scope.showVetSelector = true;
        } else {
          $scope.showVetSelector = false;
        }
        
      };

      $scope.selectVeterinarian = (provider) => {
        const providerData = { 'providers': {} };
        providerData['providers'].organization_id = provider.id;
        providerData['providers'].relation_type_id = 1;
        providerData['providers'].pet_id = $scope.currentPet.id;
        $scope.createProPetProvider($http, ENV, $rootScope.userId, $scope.currentPet.id, providerData)
          .then(async (res) => {
            $scope.$apply(() => {
              $rootScope.getData(true);
              $rootScope.refreshAdminPet($scope.currentPet.id);
              $scope.setPetData();
              $scope.showVetSelector = false;
              $scope.provider_success = 'Successfully Updated';
              $('.edit-pet-container').animate({ scrollTop: 0 });
              setTimeout(() => {
                $scope.provider_success = null;
              }, 5000);
            });
          }
        );
      };

      $scope.removeVeterinarian = (providerId) => {
        $scope.petProcessing = true;
        $scope.deleteProPetProvider($http, ENV, $rootScope.userId, $scope.currentPet.id, providerId)
          .then(async (res) => {
            $scope.$apply(() => {
              $timeout(() => {
                $rootScope.getData(true);
                $rootScope.refreshAdminPet($scope.currentPet.id);
                $scope.setPetData();
                $scope.showVetSelector = false;
                $scope.provider_success = 'Successfully Updated';
                $('.edit-pet-container').animate({ scrollTop: 0 });
                $scope.petProcessing = false;
                setTimeout(() => {
                  $scope.provider_success = null;
                }, 5000);
              }, 3000);
            });
          }
        );
      };

      
                $scope.resMsgStatus = true;
              

      $scope.createPet = () => {
        if (!$scope.currentPet.id) {
          $scope.petProcessing = true;
          const formatedDate = $filter('date')($scope.currentPet.date_of_birth, 'yyyy-MM-dd');
          const pet = {
            pet: {
              name: $scope.currentPet.name,
              breed: null,
              is_male: Boolean($scope.currentPet.is_male),
              user_id: $scope.user.id,
              species: Number($scope.currentPet.species),
              date_of_birth: formatedDate,
              petprofile: {},
            },
          };

          if (!$scope.lastBreedValue || $scope.lastBreedValue === undefined) {
            $scope.error.status = true;
            $scope.error.details = 'Please fix the highlighted field(s).';
            $scope.error.highlightedFields.breed = ['Invalid breed'];
            return;
          }
          pet.pet.breed = $scope.lastBreedValue;

          $scope
            .createProPet($http, ENV, pet)
            .then(async (res) => {
              const createdPet = res;
              await $scope.clearPetEditCreate();
              const componentHasOnCloseAction = angular.isFunction(
                $scope.activeComponentOptions?.onClose,
              );
              $scope.petProcessing = false;
              $rootScope.closeComponent();
              // if the current active component doesn't have an onClose hook, then show pet detail view after creating pet
              if (!componentHasOnCloseAction && createdPet && createdPet.id) {
                $scope.onSelectPet({ petId: createdPet.id });
              }
              $rootScope.getData();
              $rootScope.getPetDetail();
              $scope.getUser($http, ENV, $rootScope.userId);
            })
            .catch((error) => {
              if (error.status === 500) {
                $scope.error.details =
                  'There was an error with your request. Please try again in a few minutes.';
              } else if (error.status === 400) {
                $scope.error.details = 'Please fix the highlighted field(s).';
                $scope.error.highlightedFields = error.data.pet;
                if (error.data.pet.non_field_errors) {
                  $scope.error.details = error.data.pet.non_field_errors[0];
                }
              } else {
                $scope.error.details = error.statusText;
              }
              $scope.petProcessing = false;
              $scope.error.status = true;
            });
        } else {
          $scope.updatePetDetails('editpet');
        }
      };

      $scope.updatePetDetails = (key) => {
        $scope.petProcessing = true;
        const formatedDate = $filter('date')($scope.currentPet.date_of_birth, 'yyyy-MM-dd');
        const pet = {
          pet: {
            name: $scope.currentPet.name,
            breed: $scope.lastBreedValue || $scope.currentPet.breed,
            is_male: Boolean($scope.currentPet.is_male),
            user_id: $scope.currentPet.owner,
            species: Number($scope.currentPet.species),
            is_active: Boolean($scope.currentPet.is_active),
            date_of_birth: formatedDate,
            clinic_tag: $scope.currentPet.clinic_tag,
            petprofile: {},
          },
        };
        if (key === 'editpet') {
          if (!$scope.lastBreedValue) {
            $scope.error.status = true;
            $scope.error.details = 'Please fix the highlighted field(s).';
            $scope.error.highlightedFields.breed = ['Invalid breed'];
            return;
          }
        }
        if (key === 'medicalInformation') {
          pet.pet.petprofile = {
            ...pet.pet.petprofile,
            ...$scope.currentPet.petprofile,
          };
          if (Array.isArray($scope.owner_identifications)) {
            if ($scope.owner_identifications.indexOf('id_has_collar') > -1) {
              pet.pet.petprofile.id_has_collar = true;
            }
            if ($scope.owner_identifications.indexOf('id_has_tag') > -1) {
              pet.pet.petprofile.id_has_tag = true;
            }
            if ($scope.owner_identifications.indexOf('id_has_id_chip') > -1) {
              pet.pet.petprofile.id_has_id_chip = true;
            }
          }
        }

        $scope
          .updateProPet($http, ENV, $scope.currentPet.id, pet)
          .then(async () => {
            $scope.isFormDataChanged = false;
            await $rootScope.refreshAdminPet($scope.currentPet.id);
            $scope.setPetData();

            $scope.petProcessing = false;
            if (key === 'editpet') {
              $scope.pet_success = 'Successfully Updated';
              $('.edit-pet-container').animate({ scrollTop: 0 });
              setTimeout(() => {
                $scope.pet_success = null;
              }, 5000);
            } else if (key === 'medicalInformation') {
              $scope.medical_success = 'Successfully Updated';
              $('.edit-pet-container').animate({ scrollTop: 0 });
              setTimeout(() => {
                $scope.medical_success = null;
              }, 5000);
            }
            $scope.getUser($http, ENV, $rootScope.userId);
            $rootScope.getData(true);
            $rootScope.getPetDetail();
          })
          .catch((error) => {
            if (error.status === 500) {
              $scope.error.details =
                'There was an error with your request. Please try again in a few minutes.';
            } else if (error.status === 400) {
              $scope.error.details = 'Please fix the highlighted field(s).';
              $scope.error.highlightedFields = error.data.pet;
              if (error.data.pet.non_field_errors) {
                $scope.error.details = error.data.pet.non_field_errors[0];
              }
            } else {
              $scope.error.details = error.statusText;
            }
            $scope.petProcessing = false;
            $scope.error.status = true;
          });
      };

      $timeout(() => {
        if (!$scope.originalBreedList || $scope.originalBreedList.length < 1) {
          $scope.getBreeds($http, ENV);
        }
      });

      $scope.init();

      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        $scope.clearPetEditCreate();
        componentVisibleListener();
        petEditListener();
        breedListener();
      });
    },
  )
  .directive('petCreate', () => {
    return {
      templateUrl: 'templates/v2/pet-create-edit.html',
    };
  });
